import React from 'react';
import { fg } from '@atlaskit/platform-feature-flags';
import { IconWrapper as CompiledIconWrapper } from './iconWrapper-compiled';
import { IconWrapper as EmotionIconWrapper } from './iconWrapper-emotion';
export var IconWrapper = function IconWrapper(props) {
  return fg('platform_media_compiled') ? /*#__PURE__*/React.createElement(CompiledIconWrapper, props) : /*#__PURE__*/React.createElement(EmotionIconWrapper, props);
};